var map = {
	"./auth-layout.vue": "OyNA",
	"./default-layout.vue": "TK6x",
	"./empty-layout.vue": "Dxs6",
	"./error-layout.vue": "0qGa",
	"./main-layout.vue": "5Xk+",
	"./sections/extra-layout.vue": "C3HE",
	"./ui/aside-layout.vue": "wc+O"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tBSL";


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts [\w-]+-layout\.vue$
// module id = tBSL
// module chunks = 1